<template>
	<Checkbox.Root :checked="isChecked" :disabled="disabled" :id="id" class="ark-checkbox" :style="checkboxStyle">
		<Checkbox.Control class="ark-checkbox-control">
			<Checkbox.Indicator class="ark-checkbox-indicator"> ✓ </Checkbox.Indicator>
		</Checkbox.Control>
		<Checkbox.HiddenInput @change="handleNativeChange" />
	</Checkbox.Root>
</template>

<script setup>
import { Checkbox } from "@ark-ui/vue"
import { computed } from "vue"

const props = defineProps({
	checked: Boolean,
	disabled: Boolean,
	id: String,
	value: String,
	color: {
		type: String,
		default: "var(--primary-green)",
	},
})

const emit = defineEmits(["change"])

const isChecked = computed(() => props.checked)

const checkboxStyle = computed(() => ({
	"--checkbox-color": props.color,
}))

const handleNativeChange = event => {
	emit("change", event)
}
</script>

<style scoped>
.ark-checkbox {
	display: inline-flex;
	align-items: center;
}

.ark-checkbox-control {
	width: var(--spacing-md);
	height: var(--spacing-md);
	border: var(--border-width-thin) solid var(--neutral-400);
	border-radius: var(--border-radius-sm);
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: all 0.2s;
}

.ark-checkbox-control:hover {
	border-color: var(--primary-green);
}

.ark-checkbox-control[data-state="checked"] {
	background-color: var(--checkbox-color, var(--primary-green));
	border-color: var(--checkbox-color, var(--primary-green));
	color: var(--neutral-0);
}

.ark-checkbox-control[data-disabled] {
	opacity: 0.5;
	cursor: not-allowed;
}

.ark-checkbox-indicator {
	font-size: var(--font-size-small);
	line-height: var(--line-height-tight);
}
</style>
